import React from 'react';
import { Navbar } from '../components/landing/Navbar';
import { Hero } from '../components/landing/Hero';
import { ChatComparison } from '../components/landing/ChatComparison';
import { JobToBeDone } from '../components/landing/JobToBeDone';
import { RoiCalculator } from '../components/landing/RoiCalculator';
import { Integrations } from '../components/landing/Integrations';
import { HowItWorks } from '../components/landing/HowItWorks';
import { Pricing } from '../components/landing/Pricing';
import { FaqGallery } from '../components/landing/FaqGallery';
import { Blog } from '../components/landing/Blog';
export function Landing() {
  return <>
      <Navbar data-id="element-378" />
      <main className="w-full bg-white text-gray-900" data-id="element-379">
        <Hero data-id="element-380" />
        <ChatComparison data-id="element-381" />
        <JobToBeDone data-id="element-382" />
        <RoiCalculator data-id="element-383" />
        <Integrations data-id="element-384" />
        <HowItWorks data-id="element-385" />
        <Pricing data-id="element-386" />
        <FaqGallery data-id="element-387" />
        <Blog data-id="element-388" />
      </main>
    </>;
}